import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

export function useCaregiverAttendance(caregiverId: CaregiverProfileCaregiver["id"], year: number) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "attendance", year],
    queryFn: () =>
      api.get("./caregivers/:caregiverId/attendance", {
        path: { caregiverId },
        query: { year },
      }),
  });
}

export function useCaregiverAttendanceStats(caregiverId: CaregiverProfileCaregiver["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "attendanceStats"],
    queryFn: () =>
      api.get("./caregivers/:caregiverId/attendance_stats", {
        path: { caregiverId },
      }),
  });
}
